import APage from "@/classes/page/a-page";
import {IValidateErrorBag} from "@/classes/validation/validator";
import ProdApi from "@/classes/app/api/prod-api";
import {ExtEdit} from "@/classes/ext/ext-edit";
import {ExtStart} from "@/classes/ext/ext-start";
import {ExtAuthManager} from "@/classes/ext/ext-auth-manager";

export default class AProdPage extends APage {

    // Base //////////////////////////////////////////////
    public initExt() {
        super.initExt();
    }

    // Computed //////////////////////////////////////////////
    public get config(): any {
        return this.state!.config;
    }

    public get form(): any {
        return this.state!.form;
    }

    public get extEdit(): ExtEdit {
        return new ExtEdit(this);
    }

    public get extStart(): ExtStart {
        return new ExtStart(this);
    }

    public get extAuth(): ExtAuthManager {
        return new ExtAuthManager(this);
    }

    public get input(): any {
        return this.extEdit ? this.extEdit.input : {};
    }

    public get errors(): IValidateErrorBag[] {
        return this.extEdit ? this.extEdit.errors : [];
    }

    public get hasErrors(): boolean {
        return this.extEdit ? this.extEdit.hasErrors : false;
    }

    // Methods //////////////////////////////////////////////
    public error(elm: string): IValidateErrorBag | null {
        return this.extEdit.error(elm)
    }

    public hasError(elm: string): boolean {
        return this.extEdit.hasError(elm)
    }

    public classError(name: string): boolean {
        return this.extEdit.classError(name);
    }
}
